/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocio } from '../../conexiones';
import IFiltrosMarcas from './entidades/filtrosMarcas';
import IMarcas from './entidades/marcas';

export default class ModeloMarcas {
    public consultarMarcas() {
        return manejadorRest<IRespuesta<IMarcas>>(() => negocio.get('Marca/ConsultarListaMarca'));
    }
    public crearMarcas(marcas: IMarcas) {
        return manejadorRest<IRespuesta<IMarcas>>(() => negocio.post('Marca/GuardarMarca', marcas));
    }
    public editarMarcas(marcas: IMarcas) {
        return manejadorRest<IRespuesta<IMarcas>>(() => negocio.put('Marca/EditarMarca', marcas));
    }
    public eliminarMarcas(marcas: IMarcas) {
        return manejadorRest<IRespuesta<IMarcas>>(() => negocio.delete('Marca/EliminarMarca', marcas));
    }
    public consultarListaMarcasPorFiltro(filtrosMarcas: IFiltrosMarcas) {
        return manejadorRest<IRespuesta<IMarcas>>(
            () => negocio.post('Marca/ConsultarListaMarcaPorFiltro', filtrosMarcas),
            true
        );
    }
}
